// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"d92ba556","253":"f7bbfcd5","286":"d92ba556","882":"d92ba556"}[chunkId] + ".chunk.css";
};